import image_1 from '../assets/image/quality/01.webp';
import image_2 from '../assets/image/quality/02.webp';
import image_3 from '../assets/image/quality/03.webp';
import image_4 from '../assets/image/quality/04.webp';
import image_5 from '../assets/image/quality/05.webp';
import image_6 from '../assets/image/quality/06.webp';
import image_7 from '../assets/image/quality/07.webp';
import SectionDivider from "./common/SectionDivider";
import {useTranslation} from "react-i18next";
import {NewlineText} from "./common/NewlineText";

const images = [
    image_1,
    image_2,
    image_3,
    image_4,
    image_5,
    image_6,
    image_7,
];

function QualitySection() {
    const {t} = useTranslation();
    return (
        <div className="section">
            <h1 data-aos="fade-right"
                data-aos-duration="300"
                className="text-primary">{t('home_quality_header')}</h1>
            <SectionDivider/>
            <div className="space-y-0">
                <NewlineText class="space-y-0 m-0" text={t('home_quality_subtitle')}/>
            </div>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-8 max-md:gap-4">
                {
                    images.map((image, index) => (
                        <img src={image} alt={image} className="h-28 max-md:h-20" key={index}/>
                    ))
                }
            </div>
        </div>
    )
}

export default QualitySection;